export const TIPO_EMPRESA_USUARIO = {
  EMPRESA: 1,
  AUTONOMO: 2,
  ASESORIA: 3,
} as const

export type TipoEmpresaType =
  (typeof TIPO_EMPRESA_USUARIO)[keyof typeof TIPO_EMPRESA_USUARIO]
